import { Container, Typography } from '@mui/material';

const NoMatch = () => {
  return (
    <Container sx={{ marginTop: 2 }}>
      <Typography variant="h5" display="block" align="center">
        El sitio que busca no existe.
      </Typography>
    </Container>
  );
};

export default NoMatch;